window.onload = function () {
    checkFileFrame();
}
class VariantChange  extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.ChangeVariant);
    }
    ChangeVariant(e){
        if(e.target.name != 'size_type') {
            this.GetOptions();
            this.GetVariantId();
            this.UpdateUrl();
            this.UpdateContent();
        }
    }
    GetOptions() {
        this.selectedValues = Array.from(this.querySelectorAll('input[type="radio"]:not([name="size_type"])')).find((radio) => radio.checked).value

        const allRadio = this.querySelectorAll('input[type="radio"]:not([name="size_type"])');

        let checkedoptions = [];
        allRadio.forEach(function (item){
            if(item.checked){
                checkedoptions.push(item.value);
            }
        })
        this.checkedOptions = checkedoptions;

    }
    GetVariantId(){
        const variantJson = JSON.parse(this.querySelector('[type="application/json"]').textContent)

        this.currentVariant = variantJson.find((variant) => variant.title === this.checkedOptions.join(' / '));

    }
    UpdateUrl(){
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    UpdateContent(){
        this.closest('.js-product').querySelector('product-form form').querySelector('input[name="id"]').value =this.currentVariant.id;
        this.closest('.product_form').classList.add('loading');
        this.closest('.container').querySelector('#product_preview').classList.add('loading');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => {
                return response.text();
            })
            .then((response_html) => {
                const html = new DOMParser().parseFromString(response_html, 'text/html')

                const fetchPrice = html.querySelector('[data-price]');
                const fetchProductButton = html.querySelector('[data-options-group]');
                const fetchProductStatus = html.querySelector('[data-product-status]');
                const fetchProductFrame = html.querySelector('[data-frame]');
                const fetchProductButt = html.querySelector('[data-butt]');
                const fetchProductSku = html.querySelector('[data-sku]');

                const price = document.querySelector('[data-price]');
                const productButton = document.querySelector('[data-options-group]');
                const productStatus = document.querySelector('[data-product-status]');
                const productFrame = document.querySelector('[data-frame]');
                const ProductButt = document.querySelector('[data-butt]');
                const ProductSku = document.querySelector('[data-sku]');

                if(fetchProductButt && ProductButt){
                    ProductButt.innerHTML = fetchProductButt.innerHTML;
                }

                if(fetchProductSku && ProductSku){
                    ProductSku.innerHTML = fetchProductSku.innerHTML;
                }

                if(fetchProductFrame && productFrame){
                    productFrame.innerHTML = fetchProductFrame.innerHTML;
                    checkFileFrame();
                }

                if(fetchPrice && price){

                    price.innerHTML = fetchPrice.innerHTML;
                    //     price convert app
                        let bucksSelected = document.querySelector('.bucks-selected');
                        if(bucksSelected !== null){
                            let currButton = document.querySelector(`#${bucksSelected.textContent}.converterTriggers`);
                            hxo$(`#${bucksSelected.textContent}.converterTriggers`).trigger("click");
                        }
                    //     price convert app
                }

                let savedSizeType = null;
                const currentActive = document.querySelector('input[name="size_type"]:checked');
                if (currentActive) {
                    savedSizeType = currentActive.value;
                }

                if (fetchProductButton && productButton) {
                    productButton.innerHTML = fetchProductButton.innerHTML;

                    const successBtn = productButton.querySelector('.form_message.success_message button');
                    if (successBtn) {
                        successBtn.addEventListener('click', function (e) {
                            e.target.closest('.form_message.success_message').classList.add('hidden_msg');
                        });
                    }

                    if (savedSizeType) {
                        const restored = productButton.querySelector(
                            `input[name="size_type"][value="${savedSizeType}"]`
                        );
                        if (restored) {
                            restored.click();
                            convertSize();
                        }
                    }
                }

                if(fetchProductStatus && productStatus){
                    productStatus.innerHTML = fetchProductStatus.innerHTML
                }

                this.closest('.product_form').classList.remove('loading');
                this.closest('.container').querySelector('#product_preview').classList.remove('loading');
                /* - - - - - - - - - - - - - -       init count item   - - - - - - - - - - - - - - - */
                var countInputs = $(".count_input");
                if (countInputs.length) {
                    countInputs.each(function (i, elem) {
                        var input = $(elem).find("input");
                        var decBtn = $(elem).find(".count_input-dec");
                        var incBtn = $(elem).find(".count_input-inc");
                        var inc = function inc() {
                            var value = input.val();
                            input.val(+value + 1);
                            $(decBtn).removeClass("disabled")
                        };
                        var dec = function dec() {
                            var value = input.val();
                            if (+value > 0) {
                                input.val(+value - 1)
                            } else {
                                input.val(0)
                            }
                            if (+value > 1) {
                                $(decBtn).removeClass("disabled")
                            } else {
                                $(decBtn).addClass("disabled")
                            }
                        };
                        decBtn.on("click", dec);
                        decBtn.on("keydown", function (e) {
                            if (e.keyCode === 13) {
                                dec()
                            }
                        });
                        incBtn.on("click", inc);
                        incBtn.on("keydown", function (e) {
                            if (e.keyCode === 13) {
                                inc()
                            }
                        });
                        $(input).on("input", function () {
                            if (+$(input).val()) {
                                $(decBtn).removeClass("disabled")
                            } else {
                                $(decBtn).addClass("disabled")
                            }
                        })
                    })
                }
                swatchAccordion();
                setTimeout(() => {
                    var sizeRadio = $("input[name=\"size_type\"]");
                    sizeRadio.each(function () {
                        $(this).on("change", convertSize)
                    });
                }, 500);
            }) .catch((e) => {
            console.error(e);
        });
    }
}
customElements.define('variant-button', VariantChange )
function swatchAccordion() {
    var accordionItems = document.querySelectorAll(".accordion-select");
    accordionItems.forEach(function (item) {
        item.addEventListener("click", function (e) {
            if (e.target.closest(".product_form-header")) {
                e.target.closest(".accordion-select").classList.toggle("active");
                if (e.target.closest(".accordion-select").classList.contains("active")) {
                    document.addEventListener("click", function (a) {
                        if (!a.target.closest(".product_form-row.accordion-select")) {
                            e.target.closest(".accordion-select").classList.remove("active")
                        }
                    })
                }
            }
        })
        item.querySelector('input').addEventListener('change', function (e) {
            if (e.target.closest(".product_form-dropdown-list-item")) {
                // e.preventDefault();
                item.querySelectorAll(".product_form-dropdown-list-item.active").forEach(function (it) {
                    it.classList.remove("active")
                });
                e.target.closest(".product_form-dropdown-list-item").classList.add("active");
                var checkedValue = e.target.closest(".product_form-dropdown-list-item").querySelector("input").value;
                item.querySelector(".product_form-header_title").textContent = checkedValue;
                e.target.closest(".accordion-select").classList.toggle("active");
                e.target.closest(".accordion-select").classList.add("checked")
            }
        })
    })
}

function checkFileFrame() {
    if(document.querySelector('.product_info-box-framing img') !== null){
        let imgFrimming = document.querySelectorAll('.product_info-box-framing img');
        imgFrimming.forEach(function (item) {
            let imgSrc = item.src;
            $.ajax(imgSrc, {
                success: function(e) {
                    if(document.querySelector('.product_info-box-framing')){
                        document.querySelector('.product_info-box-framing').removeAttribute('style')
                    }
                },
                error: function(e) {
                    item.remove();
                },
                method: "HEAD"
            });
        })
    }
}
function convertSize() {
    var hasNumber = function hasNumber(str) {
        return /[0-9]/.test(str);
    };
    var _$$parents$find;
    var activeSizeType = document.querySelector("input[name=\"size_type\"]:checked");
    var sizeTypeValue = activeSizeType.getAttribute("value");// const sizeRadio = $('input[name="size"]');
    var sizeRadio = $("input[data-name=\"options[size]\"]");
    var currentOptionText = $(".product_form-row.size .product_form-header_title");
    var checkedRadioLabel = (_$$parents$find = $(sizeRadio).parents(".product_form-dropdown-list-item.active").find("label")) === null || _$$parents$find === void 0 ? void 0 : _$$parents$find[0];
    sizeRadio.each(function (i, elem) {
        var sizeValue = $(this).attr("value");
        var title = activeSizeType.dataset.title ? activeSizeType.dataset.title : false;
        var multiplier = activeSizeType.dataset.multiplier ? parseFloat(activeSizeType.dataset.multiplier) : false;
        var sizeValues = sizeValue.split("-").map(function (el) {
            if (hasNumber(el.trim())) {
                var elNumbers = el.trim().split("x").map(function (item) {
                    var value = parseFloat(item.trim());
                    if (multiplier) {
                        value = (value * multiplier).toFixed(2)
                    }
                    return value
                });
                return elNumbers.join(" x ")
            }
            return el.trim()
        });
        var newValue = sizeValues.join(" - ") + (title ? " ".concat(title) : "");
        var label = elem.nextElementSibling;
        label.innerHTML = newValue;
        if (currentOptionText && checkedRadioLabel) {
            currentOptionText === null || currentOptionText === void 0 || currentOptionText.text(checkedRadioLabel.textContent)
        }
    })
}
